/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Upload_Gate_Hint_Case_TypeInputs */

const en_case_upload_gate_hint_case_type = /** @type {(inputs: Case_Upload_Gate_Hint_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a case type to enable uploads.`)
};

const pt_br2_case_upload_gate_hint_case_type = /** @type {(inputs: Case_Upload_Gate_Hint_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o tipo de caso para habilitar o envio de arquivos.`)
};

/**
* | output |
* | --- |
* | "Select a case type to enable uploads." |
*
* @param {Case_Upload_Gate_Hint_Case_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_upload_gate_hint_case_type = /** @type {((inputs?: Case_Upload_Gate_Hint_Case_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Upload_Gate_Hint_Case_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_upload_gate_hint_case_type(inputs)
	return pt_br2_case_upload_gate_hint_case_type(inputs)
});